import React, { Component } from 'react'
import Draggable from 'react-draggable';

import classNames from './OrchestraArrange.css'

export default class OrchestraArrangeSpawner extends Component {

  render () {
    const { xPos, yPos, angleRad, breadth, onStop } = this.props;
    const spawnPos = { x: xPos, y: yPos };
    const angleStyle = {
      transform: `rotate(${angleRad}rad)`,
      transformOrigin: 'top left'
    };
    const breadthStyle = {
      transformOrigin: 'top left',
      transform: `rotate(${angleRad + (Math.PI / 2)}rad) translate(-${breadth / 2.0}px, 0px)`,
      width: `${breadth}px`
    };

    return (

        <Draggable
          onStop={onStop}
          bounds={'parent'}
          position={spawnPos}
        >
            <div className={classNames.spawner}>
              <div className={classNames.spawnAngle} style={angleStyle}/>
              <div className={classNames.spawnBreadth} style={breadthStyle}/>
            </div>

        </Draggable>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/orchestra/OrchestraArrangeSpawner.js